module.exports = __webpack_public_path__ + "static/media/Portrait-10215.7228f012.jpg";